<template lang="html">

  <div class="contacto">

    <section class="middle-intro row-start">
      
      <div class="container">
        <h1 class="title -intro">{{$t('contacto.title')}}</h1>
             <img src="/static/img/gifs/contacto.gif" alt="contacto" class="imagen-animacion">
      </div>

    </section>

    <div class="container row-between aifs fww">

      <div class="contenedor-formulario">
        <formulario></formulario>
      </div>

      <div class="contenedor-info">

        <div class="info">

          <h2 class="title">
            {{$t('contacto.boxAdress.title')}}
          </h2>

          <div class="datos">

            <p class="direccion" v-html="$t('contacto.boxAdress.direccion')"> </p>
            <p class="telefono"><a :href="$t('contacto.boxAdress.telTo')" @click="trackPhoneClick">{{$t('contacto.boxAdress.tel')}}</a></p>
            <p class="mail"><a :href="$t('contacto.boxAdress.mailto')">{{$t('contacto.boxAdress.mail')}}</a></p>

          </div>

        </div>

        <!-- <img class="mapa" src="/static/img/mapa.jpg" alt=""> -->

      </div>
    </div>
  </div>
  

</template>

<script lang="js">

  import formulario from '@/components/view-parts/contacto/formulario'

  export default  {
    name: 'contacto',
    props: [],
  mounted() {
    if (typeof gtag !== 'undefined') {
      gtag('config', 'AW-663879014/5seZCMTRq_oaEOb6x7wC', {
        phone_conversion_number: '+34 91 142 78 87',
      });
    }
  },
    data() {
      return {

      }
    },
  methods: {
    trackPhoneClick() {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
          send_to: 'AW-663879014/5seZCMTRq_oaEOb6x7wC',
          phone_conversion_number: '+34 91 142 78 87',
        });
      }
    }
  },
    components: {
     formulario
   }
 }
</script>

<style scoped >
.contacto {

}

.contenedor-formulario{
  width: 50%;
  max-width: 400px;
}

.contenedor-info{
  width: 100%;
  max-width: calc(100% - 500px);
 margin-top: 120px;
}

.info{
  background: #3374b0;
  padding: 50px;
  color: #fff;
  text-align: left;
  position: relative;
  overflow: hidden;
  animation-name: showInfo;
  animation-duration: .5s;
  animation-delay: .5s;
  animation-fill-mode: forwards;
  transform: translateY(110%);
  will-change:transform;
}

.info::before{
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: 2;
  content: '';
  background: #3374b0;
  animation-name: removeTelon;
  animation-duration: .5s;
  animation-delay: 1s;
  animation-fill-mode: forwards;
}

.info .telefono::after{
  width: 200px;
  height: 200px;
  content: '';
  background: url(https://media.giphy.com/media/3oKIP8KKYpv11ivQ1G/giphy.gif) center/200px no-repeat;
  position: absolute;
  right: 0;
  bottom: -6px;
  opacity: 0;
  transition: .5s;
  transition-delay: 0s;
  pointer-events: none;
}

.info .telefono:hover::after{
  opacity: 1;
  transition-delay: 2s;
}

@keyframes removeTelon{
  to {
    transform: translateY(110%);
  }
}

@keyframes showInfo{
  to {
    transform: translateY(0%);
  }
}

.title:not(.-intro){
  margin-bottom: 20px;
}

.datos{
  max-width: 350px;
}

.datos p{
  padding-left: 35px;
  line-height: 24px;
  min-height: 40px;
  margin-bottom: 20px;
}

.datos .direccion{
  background: url(/static/img/icon-direccion.svg) left 5px/25px no-repeat;
}

.datos .telefono{
  background: url(/static/img/icon-telefono.svg) center left/20px no-repeat;
  line-height: 40px;
}

.datos .mail{
  background: url(/static/img/icon-email.svg) center left/26px no-repeat;
  line-height: 40px;
}

.mapa{
  width: 100%;
  position: relative;
  z-index: 2;
}

@media screen and (max-width: 900px){

  .contenedor-formulario{
    width: 100%;
    max-width: 100%;
  }

  .contenedor-info{
    margin-top: 30px;
    max-width: 100%;
  }

}

@media screen and (max-width: 600px){
  .info{
    padding: 20px;
  }

  .info .title{
    font-size: 20px;
  }

  .datos p{
    line-height: 20px;
  }
}




</style>



// WEBPACK FOOTER //
// src/components/views/contacto.vue